/** Angular Imports */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';

/** Custom Services */
import { SettingsService } from 'app/settings/settings.service';
import { SavingsTransactionsServiceService } from '../savings-transactions-service.service';
import { AccountSearchSummary } from 'app/model/accountsearchsummary';
import { SavingsAccountTransctionTemplate } from 'app/model/savingsaccounttransctiontemplate';
import { Router, ActivatedRoute } from '@angular/router';
import { CheckDetails } from 'app/model/checkdetails';
import { MatTableDataSource } from '@angular/material/table';
import { TellerGlobalServiceService } from 'app/shared/teller-data/teller-global-service.service';
import { ReceiptServiceService } from 'app/shared/receipt-dialog/receipt-service.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogHelper } from 'app/core/utils/dialog-helper';
import { SelectedCurrencyOptions } from 'app/model/currencyoptions';
import { Observable, Subscription } from 'rxjs';
import { OTPRequestData } from 'app/model/tillotp';


/**
 * Create savings account transactions component.
 */
@Component({
  selector: 'savings-transaction',
  templateUrl: './savings-transaction.component.html',
  styleUrls: ['./savings-transaction.component.scss']
})
export class SavingsTransactionComponent implements OnInit, OnDestroy {

  /** Savings account transaction form. */
  savingAccountTransactionForm: FormGroup;
  /** savings account transaction payment options. */
  paymentTypeOptions: {
    id: number,
    name: string,
    description: string,
    isCashPayment: boolean,
    position: number
  }[];
  /** Flag to enable payment details fields. */
  addPaymentDetailsFlag: Boolean = false;
  isSavingsFull: Boolean = false;
  accumulatedSavingsInTransactions = 0.0;
  /** transaction type flag to render required UI */
  transactionType: { deposit: boolean, withdrawal: boolean } = { deposit: false, withdrawal: false };
  /** transaction command for submit request */
  transactionCommand: string = 'deposit';
  labelButton: string = '';
  isDisabledPaymentType: Boolean = false;
  /** Flag to enable payment details fields. */
  addCheckDetailsFlag: Boolean = false;
  savingsAccountDetail: Array<any>;
  savingsAccountDepositTemplate: SavingsAccountTransctionTemplate;
  savingsAccountDepositTemplateCauses: any;
  showDepositView: boolean = false;
  showClientToOrder: boolean = false;
  showCheckDetailsView: Boolean = false;
  savingAccountSummary: AccountSearchSummary;
  isDisabled: Boolean = false;
  montoMaximoTransaccionesCuentaLigth: Number = 1000;
  /** Check Details */
  checkDetailsTable = new MatTableDataSource<CheckDetails>();
  checkDetails: Array<CheckDetails> = [];
  checkDetail: CheckDetails = {
    id: 0,
    checkAccountNumber: '',
    checkNumber: '',
    checkSecurityNumber: '',
    checkAmount: '',
    checkAmountToDeposit: '',
    targetName: '',
    countryCode: '',
    currencyCode: null,
    bankCode: '',
    locale: ''
  };

  checkForm: FormGroup;
  selectedTeller: any;
  tellerSub: Subscription;

  /** Handle transaction approval */
  approvalDialogRef: Observable<any>;
  approvalData = {};

  /**
   * List of supported currencies
   */
  currencyOptions: SelectedCurrencyOptions;

  /**
   * Retrieves the Saving Account transaction template data from `resolve`.
   * @param {FormBuilder} formBuilder Form Builder.
   * @param {TransactionsService} transactionService TransactionService Service.
   * @param {DatePipe} datePipe DatePipe.
   * @param {Router} router Router for navigation.
   */
  constructor(private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private settingsService: SettingsService,
    private transactionService: SavingsTransactionsServiceService,
    private router: Router,
    private route: ActivatedRoute,
    private tellerGlobalService: TellerGlobalServiceService,
    private receiptService: ReceiptServiceService,
    private matDialog: MatDialog,
    private dialogHelper: DialogHelper) {

    this.transactionCommand = this.route.snapshot.params['name'].toLowerCase();
    this.transactionType[this.transactionCommand] = true;
  }

  /**
   * Creates the Saving account transaction form when component loads.
   */
  ngOnInit() {
    this.createSavingAccountTransactionForm();
    this.createCheckForm();
    this.tellerSub = this.tellerGlobalService.getSelectedTeller$().subscribe(data => this.selectedTeller = data);
    this.route.data.subscribe(({ supportedCurrencies }) => {
      this.currencyOptions = supportedCurrencies;
    })

    if (this.transactionType.deposit) {
      this.labelButton = "Depositar";
    } else if (this.transactionType.withdrawal) {
      this.labelButton = "Retirar";
    }
  }

  ngOnDestroy() {
    if (this.tellerSub) {
      this.tellerSub.unsubscribe();
    }
  }

  /**
   * Method to create the Saving Account Transaction Form.
   */
  createSavingAccountTransactionForm() {
    this.savingAccountTransactionForm = this.formBuilder.group({
      'currencyCode': ['', Validators.required],
      'transactionAmount': ['', Validators.required],
      'paymentTypeId': [''],
      'paymentCauseId': [''],
      'note': ['']
    });
    if (this.transactionType.withdrawal == true) {
      this.savingAccountTransactionForm.addControl('cashierName', new FormControl(''));
      this.savingAccountTransactionForm.addControl('authorizationNumber', new FormControl(''));
      this.savingAccountTransactionForm.addControl('identificationNo', new FormControl(''));
    }
  }

  createCheckForm() {
    this.checkForm = this.formBuilder.group({
    });
  }

  /**
   * Method to add payment detail fields to the UI.
   */
  addPaymentDetails() {
    this.addPaymentDetailsFlag = !this.addPaymentDetailsFlag;
    if (this.addPaymentDetailsFlag) {
      this.savingAccountTransactionForm.addControl('accountNumber', new FormControl(''));
      this.savingAccountTransactionForm.addControl('checkNumber', new FormControl(''));
      this.savingAccountTransactionForm.addControl('routingCode', new FormControl(''));
      this.savingAccountTransactionForm.addControl('receiptNumber', new FormControl(''));
      this.savingAccountTransactionForm.addControl('bankNumber', new FormControl(''));
    } else {
      this.savingAccountTransactionForm.removeControl('accountNumber');
      this.savingAccountTransactionForm.removeControl('checkNumber');
      this.savingAccountTransactionForm.removeControl('routingCode');
      this.savingAccountTransactionForm.removeControl('receiptNumber');
      this.savingAccountTransactionForm.removeControl('bankNumber');
    }
  }

  /**
 * Method to add payment detail fields to the UI.
 */
  addCheckDetails() {
    this.addCheckDetailsFlag = !this.addCheckDetailsFlag;
    if (this.addCheckDetailsFlag) {
      this.checkForm.addControl('checkAccountNumber', new FormControl(''));
      this.checkForm.addControl('chequeNumber', new FormControl(''));
      this.checkForm.addControl('checkSecurityNumber', new FormControl(''));
      this.checkForm.addControl('checkAmount', new FormControl(''));
      //this.checkForm.addControl('checkAmountTo', new FormControl(''));
      this.checkForm.addControl('targetName', new FormControl(''));
      this.checkForm.addControl('chequeCountry', new FormControl(1270));
      this.checkForm.addControl('chequeBank', new FormControl(''));
    } else {
      this.checkForm.removeControl('checkAccountNumber');
      this.checkForm.removeControl('chequeNumber');
      this.checkForm.removeControl('checkSecurityNumber');
      this.checkForm.removeControl('checkAmount');
      //this.checkForm.removeControl('checkAmountTo');
      this.checkForm.removeControl('targetName');
      this.checkForm.removeControl('chequeCountry');
      this.checkForm.removeControl('chequeBank');
    }
  }

  updateAccountDetail(event: Array<AccountSearchSummary[]>) {
    this.savingsAccountDetail = event;
    if (this.savingsAccountDetail.length > 0) {
      this.savingAccountSummary = this.savingsAccountDetail[0];

      if (this.transactionType.deposit) {
        this.transactionService.getIsSavingsAccountFull<SavingsAccountTransctionTemplate>(this.savingAccountSummary.entityId.toString())
          .subscribe(res => {
            if (res.data && res.data.length > 0) {
              if (res.data[0].row[2] === "1") {
                this.isSavingsFull = true;
                this.accumulatedSavingsInTransactions = Number(res.data[0].row[3]);
                this.transactionService.getSavingsAccountTransactionTemplate<SavingsAccountTransctionTemplate>(this.savingAccountSummary.entityId.toString(), 'template')
                  .subscribe(res => {
                    this.savingsAccountDepositTemplate = res;
                    this.isDisabledPaymentType = false;

                    this.savingsAccountDepositTemplateCauses = res.causes.filter((obj: any) => {
                      return obj.operationType === "C" && obj.isShownInCashierModule === true;
                    });

                    this.showDepositView = true

                  });

              } else if (res.data[0].row[2] === "0" && Number(res.data[0].row[3]) <= this.montoMaximoTransaccionesCuentaLigth) {
                this.isSavingsFull = false;
                this.accumulatedSavingsInTransactions = Number(res.data[0].row[3]);
                this.transactionService.getSavingsAccountTransactionTemplate<SavingsAccountTransctionTemplate>(this.savingAccountSummary.entityId.toString(), 'template')
                  .subscribe(res => {
                    this.savingsAccountDepositTemplate = res;
                    this.isDisabledPaymentType = false;

                    this.savingsAccountDepositTemplateCauses = res.causes.filter((obj: any) => {
                      return obj.operationType === "C" && obj.isShownInCashierModule === true;
                    });

                    this.showDepositView = true

                  });

              } else {
                alert("No se han completado los datos de la cuenta ingresada, finalice el proceso desde el App Nexa")
              }
            } else {
              alert("No se pudo validar el estado de la cuenta ingresada, intente nuevamente")
            }
          });
      } else if (this.transactionType.withdrawal) {
        this.transactionService.getSavingsAccountTransactionTemplate<SavingsAccountTransctionTemplate>(this.savingAccountSummary.entityId.toString(), 'template')
          .subscribe(res => {
            this.savingsAccountDepositTemplate = res;
            this.savingAccountTransactionForm.controls['paymentTypeId'].setValue(1);
            this.isDisabledPaymentType = true;

            this.savingsAccountDepositTemplateCauses = res.causes.filter((obj: any) => {
              return obj.isCashOperation === true && obj.operationType === "D" && obj.isShownInCashierModule === true;
            });

            this.savingAccountTransactionForm.controls['currencyCode'].setValue(this.savingsAccountDepositTemplate.currency.code);
            this.showClientToOrder = this.savingAccountSummary.entityStatus.id === 900;
            this.checkForEnableCheckOption(1);

            this.showDepositView = true
          });
      }

    } else {
      this.showDepositView = false;
    }
  }

  checkForEnableCheckOption(value: any) {
    this.showCheckDetailsView = (value === 2 || value === 3);
    if (this.transactionType.deposit) {
      if (!this.showCheckDetailsView) {
        this.savingsAccountDepositTemplateCauses = this.savingsAccountDepositTemplate.causesTemplate.filter((obj: any) => {
          return obj.operationType === "C" && obj.isShownInCashierModule === true && obj.isCashOperation === true;
        });
      } else {
        this.savingsAccountDepositTemplateCauses = this.savingsAccountDepositTemplate.causesTemplate.filter((obj: any) => {
          return obj.operationType === "C" && obj.isShownInCashierModule === true && obj.isCashOperation === false;
        });
      }
    }
  }

  clearCheckFields() {
    this.checkForm.get('checkAccountNumber').setValue('');
    this.checkForm.get('chequeNumber').setValue('');
    this.checkForm.get('checkSecurityNumber').setValue('');
    this.checkForm.get('checkAmount').setValue('');
    //this.checkForm.get('checkAmountTo').setValue('');
    this.checkForm.get('targetName').setValue('');
    this.checkForm.get('chequeCountry').setValue(1270);
    this.checkForm.get('chequeBank').setValue('');
  }

  addNewCheck() {

    let checkData = {} as CheckDetails;

    checkData.id = this.checkDetails.length;
    checkData.checkAccountNumber = this.checkForm.get('checkAccountNumber').value;
    checkData.checkNumber = this.checkForm.get('chequeNumber').value;
    checkData.checkSecurityNumber = this.checkForm.get('checkSecurityNumber').value;
    checkData.checkAmount = this.checkForm.get('checkAmount').value;
    checkData.checkAmountToDeposit = this.checkForm.get('checkAmount').value;
    checkData.targetName = this.checkForm.get('targetName').value;
    checkData.countryCode = this.checkForm.get('chequeCountry').value;
    checkData.bankCode = this.checkForm.get('chequeBank').value;
    checkData.locale = this.settingsService.language.code;

    this.checkDetails.push(checkData);
    this.checkDetailsTable.data = this.checkDetails;
    this.clearCheckFields();
  }

  removeCheck(id: number) {
    this.checkDetails.splice(id, 1);
    this.checkDetailsTable.data = this.checkDetails;
  }

  /**
   * Method to submit the transaction details.
   */
  submit() {

    if (this.savingAccountTransactionForm.valid) {
      const newaccumulatedSavingsInTransactions = Number(this.savingAccountTransactionForm.get('transactionAmount').value) + this.accumulatedSavingsInTransactions;

      if (this.isSavingsFull == false && newaccumulatedSavingsInTransactions > this.montoMaximoTransaccionesCuentaLigth && this.transactionType.deposit) {

        alert("El monto a depositar es mayor al permitido para una cuenta Light, complete el perfil dese el App para realizar la transacción.")

      } else {
        this.isDisabled = true;
        // TODO: Update once language and date settings are setup
        const dateFormat = this.settingsService.dateFormat;
        const locale = this.settingsService.language.code;
        const transactionData = {
          ...this.savingAccountTransactionForm.value,
          //Todo date should come from remote server
          transactionDate: this.datePipe.transform(new Date(), dateFormat),
          locale,
          dateFormat,
          channel: 'caja',
          ...this.approvalData
        }
        if (this.checkDetails.length > 0) {

          let txnCurrency = this.currencyOptions.selectedCurrencyOptions.find((c) => {
            return c.code == transactionData['currencyCode'];
          });

          console.log(txnCurrency);
          this.checkDetails.forEach((check) => {
            check.currencyCode = txnCurrency.intCode;
          });

          transactionData['checksDetails'] = this.checkDetails
        }
        this.approvalData = {};
        this.transactionService.executeSavingsAccountTransactionsCommand(this.savingAccountSummary.entityId.toString(),
          this.transactionCommand, transactionData).subscribe(res => {

            if (res.hasOwnProperty('httpStatusCode') && res.httpStatusCode === '202' && res.userMessageGlobalisationCode == 'response.msg.approval.required') {
              const amount = this.savingAccountTransactionForm.get('transactionAmount').value;
              const currencyCode = this.savingAccountTransactionForm.get('currencyCode').value;

              let title = `Approve ${this.transactionCommand} of ${amount} ${currencyCode}`;
              if(this.savingAccountSummary.entityStatus.id === 900){
                title = `Approve ${this.transactionCommand} of ${amount} ${currencyCode} for Account to Order `;
              }

              let transactionAmount = Number(String(this.savingAccountTransactionForm.get('transactionAmount').value).replace(/,/g, '').replace('.', '.'));

              const otpRequestData: OTPRequestData = {
                requestAmount:transactionAmount, 
                entityId: this.savingAccountSummary.entityId,
                title: title,
              }
              this.approvalDialogRef = this.dialogHelper.showApprovalDialog(otpRequestData, this.matDialog).afterClosed();
              this.approvalDialogRef.subscribe(result => {

                if (result && result.hasOwnProperty('approvalToken')) {
                  this.approvalData = result;
                  this.submit();
                }

              });
            } else {
              this.receiptService.getTellerReport(this.selectedTeller['id'], `Caja_${this.transactionCommand}`, res['resourceId']).subscribe(data =>
                this.dialogHelper.showDialog(data, this.matDialog, this.router, this.route));

            }
          }, error => {
            this.isDisabled = false;
          });
      }
    } else {
      alert("No ha completado todos los campos, intente nuevamente.")
    }
  }
}
